<div class="row g-3 align-items-center" *ngIf="locationInfo | async">
	<div class="col-md-7 mt-8">
		<div class="row">
			<div class="col-md-12">
				<!-- <div #map style="height: 740px; width: 100%"></div> -->
				<div style="height: 740px; width: 100%;">
					<kt-generic-map [mapModel]="genericMapModel"></kt-generic-map>
				</div> 
			</div>
		</div>
	</div>
	<div class="col-md-5 mt-8">
		<div class="row">
			<!--MPOI Noktaya Olan Uzaklık Giriş-->
			<div class="col-md-6">
				<label for="girisUzaklik" class="form-label">Noktaya Olan Uzaklık Giriş</label>
				<input id="girisUzaklik" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.anaNoktayaUzaklikGirisMt + ' Mt'" readonly/>
			</div>

			<!--MPOI Noktaya Olan Uzaklık Çıkış-->
			<div class="col-md-5">
				<label for="cikisUzaklik" class="form-label">Noktaya Olan Uzaklık Çıkış</label>
				<input id="cikisUzaklik" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.anaNoktayaUzaklikCikisMt + ' Mt'" readonly/>
			</div>			

			<!--Personel adı-->
			<div class="col-md-6">
				<label for="personel" class="form-label">Personel</label>
				<input id="personel" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.personelAdi" readonly />
			</div>

			<!--Calisma gunu-->
			<div class="col-md-5">
				<label for="calismaGunu" class="form-label">Çalışma günü</label>
				<input id="calismaGunu" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.calismaGunu" readonly />
			</div>

			<!--MPOI Mağaza Adı-->
			<div class="col-md-6">
				<label for="mpoi" class="form-label">Mağaza Adı</label>
				<input id="mpoi" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.magazaAdi" readonly />
			</div>

			<!--Ziyaret Kabul Mesafesi-->
			<div class="col-md-5">
				<label for="distance" class="form-label">Ziyaret Kabul Mesafesi (Mt)</label>
				<input id="distance" type="number" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.ziyaretKabulMesafesi" readonly />
			</div>

			<!--MPOI Mağaza Adresi-->
			<div class="col-md-11">
				<label for="mpoiAddress" class="form-label">Mağaza Adresi</label>
				<input id="mpoiAddress" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.magazaAdres" readonly/>
			</div>			

			<!--Planlanan Giriş Tarihi-->
			<div class="col-md-6">
				<label for="checkInDate" class="form-label">Planlanan Giriş Tarihi</label>
				<input id="checkInDate" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo?.value.planlananGirisTarihi" readonly />
			</div>

			<!--PoiEnlem-->
			<div class="col-md-5">
				<label for="poiEnlem" class="form-label">Nokta Enlem</label>
				<input id="poiEnlem" type="number" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.poiEnlem" readonly />
			</div>

			<!--Planlanan Çıkış Tarihi-->
			<div class="col-md-6">
				<label for="checkOutDate" class="form-label">Planlanan Çıkış Tarihi</label>
				<input id="checkOutDate" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo?.value.planlananCikisTarihi" readonly />
			</div>

			<!--PoiBoylam-->
			<div class="col-md-5">
				<label for="poiBoylam" class="form-label">Nokta Boylam</label>
				<input id="poiBoylam" type="number" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.poiBoylam" readonly />
			</div>

			<!--Gorev Durumu-->
			<div class="col-md-4">
				<label for="gorevDurumu" class="form-label">Görev Durumu</label>
				<input id="gorevDurumu" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.gorevDurumu" readonly />
			</div>

			<!--GorevTipi-->
			<div class="col-md-4">
				<label for="gorevTipi" class="form-label">Görev Tipi</label>
				<input id="gorevTipi" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.gorevTipi" readonly />
			</div>

			<!--Gorev Suresi (dk)-->
			<div class="col-md-3">
				<label for="gorevSuresi" class="form-label">Görev Süresi</label>
				<input id="gorevSuresi" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.gorevSuresiDk + ' dk'" readonly />
			</div>

			<!--Gerçekleşen Giriş Tarihi-->
			<div class="col-md-6">
				<label for="gerceklesenGirisTarihi" class="form-label">Gerçekleşen Giriş Tarihi</label>
				<input id="gerceklesenGirisTarihi" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo?.value.gerceklesenGirisTarihi" readonly />
			</div>

			<!--Giriş Enlem-->
			<div class="col-md-5">
				<label for="girisEnlem" class="form-label">Giriş Enlem</label>
				<input id="girisEnlem" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.girisEnlem" readonly />
			</div>

			<!--Gerçekleşen Çıkış Tarihi-->
			<div class="col-md-6">
				<label for="gerceklesenCikisTarihi" class="form-label">Gerçekleşen Çıkış Tarihi</label>
				<input id="gerceklesenCikisTarihi" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo?.value.gerceklesenCikisTarihi" readonly />
			</div>

			<!--Giriş Boylam-->
			<div class="col-md-5">
				<label for="girisBoylam" class="form-label">Giriş Boylam</label>
				<input id="girisBoylam" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.girisBoylam" readonly />
			</div>

			<!--Giriş Sapma Değeri-->
			<div class="col-md-6">
				<label for="girisSapmaDegeri" class="form-label">Giriş Sapma Değeri</label>
				<input id="girisSapmaDegeri" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.girisSapmaDegeri" readonly />
			</div>

			<!--Çıkış Enlem-->
			<div class="col-md-5">
				<label for="cikisEnlem" class="form-label">Çıkış Enlem</label>
				<input id="cikisEnlem" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.cikisEnlem" readonly />
			</div>

			<!--Çıkış Sapma Değeri-->
			<div class="col-md-6">
				<label for="cikisSapmaDegeri" class="form-label">Çıkış Sapma Değeri</label>
				<input id="cikisSapmaDegeri" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.cikisSapmaDegeri" readonly />
			</div>

			<!--Çıkış Boylam-->
			<div class="col-md-5">
				<label for="cikisBoylam" class="form-label">Çıkış Boylam</label>
				<input id="cikisBoylam" type="text" class="form-control bg-secondary text-muted border-0" [value]="locationInfo.value.cikisBoylam" readonly />
			</div>

		</div>
	</div>
</div>
